export default __webpack_public_path__ + "static/media/business-21.99e8d1a4.png";